export const navButtons = {
  firstPage: {
    name: "Rewind",
    buttonLabel: "move to the first page"
  },
  prevPage: {
    name: "ChevronLeft",
    buttonLabel: "move to the previous page"
  },
  nextPage: {
    name: "ChevronRight",
    buttonLabel: "move to the next page"
  },
  lastPage: {
    name: "FastForward",
    buttonLabel: "move to the last page"
  }
};
